import { isEmpty as lodashEmpty } from 'lodash';

/**
 * Проверяет, является ли переданная переменная пустой.
 *
 * Метод возвращает `true`, если переменная пуста, и `false` в противном случае.
 * Пустыми считаются значения, соответствующие результату работы функции lodashEmpty.
 *
 * @template T Тип переменной, которая проверяется.
 * @param {unknown} variable Переменная, которую нужно проверить на пустоту.
 * @returns {variable is T} Булевый флаг, указывающий, является ли переменная пустой.
 */
export const isEmpty = <T>(variable: unknown): variable is T =>
  lodashEmpty(variable);
